import type { LowerResultsCategory } from "./lower-results.dto";
import type { PerformanceByQuestionCategory } from "./performance-by-question-category.dto";

import { api } from "../core/api";

interface GeneralStatisticsDto {
  total_stations: number;
  statistics: [
    {
      name: string;
      quantity: number;
      application_avg_score: number;
      avg_score: number;
    }
  ];
}
export const getGeneralStatistics = async (): Promise<GeneralStatisticsDto> => {
  const response = await api.get("/api/v1/users/dashboard/general_statistics");
  return response.data.data;
};

export const getPerformanceByQuestionCategory = async (): Promise<
  PerformanceByQuestionCategory[]
> => {
  const response = await api.get(
    "/api/v1/users/dashboard/performance_by_question_category"
  );
  return response.data.data;
};

export const getLowerResults = async (): Promise<LowerResultsCategory[]> => {
  const response = await api.get("/api/v1/users/dashboard/lower_results");
  return response.data.data;
};

interface UserScore {
  average_score: number;
  cutoff_score: number;
}
export const getUserScore = async (): Promise<UserScore> => {
  const response = await api.get("/api/v1/users/dashboard/user_score");

  return {
    average_score: response.data.data["average_score="],
    cutoff_score: response.data.data["cutoff_score="],
  };
};

interface UsersRanking {
  data: {
    user: {
      id: string;
      name: string;
      application_ranking: number;
      avg_score: number;
      avatar_url?: string;
    };
  }[];
}
export const getUsersRanking = async (): Promise<UsersRanking> => {
  const res = await api.get("/api/v1/users/dashboard/application_top_five");
  return res.data;
};

interface ScenariosCategories {
  categories: {
    id: string;
    name: string;
    user_tests: number;
    banner_url: string;
  }[];
  total_scenarios: number;
}
export const getScenariosCategories =
  async (): Promise<ScenariosCategories> => {
    const res = await api.get(
      "/api/v1/users/dashboard/user_test_category_scenarios"
    );
    const data: ScenariosCategories = res.data.data;
    return data;
  };
